'use strict';
var unitas = unitas || {};
const traveldescription = document.getElementById('js-page-travel-description-text-inner');
const showmoreTextTrigger = document.getElementById('js-page-travel-description-show-more');

unitas.traveldescription = unitas.traveldescription || function () {
	function init() {
        setupShowMoreText();
	}

    function setupShowMoreText() {

        if(traveldescription && showmoreTextTrigger) {
            showmoreTextTrigger.addEventListener('click', function(){
                if (traveldescription.style.maxHeight) {
                    traveldescription.classList.remove('open');
                    showmoreTextTrigger.classList.remove('open');
                    traveldescription.style.maxHeight = null;
                } else {
                    traveldescription.classList.add('open');
                    showmoreTextTrigger.classList.add('open');
                    traveldescription.style.maxHeight = traveldescription.scrollHeight + "px";
                }
            });
        }
    }

	return {
		init : init
	};
}();